import { useMemo } from "react";
import { IInvalidField } from "shared";

import {
  IOption,
  ISelectProps,
  Select,
} from "../../../common/Atoms/Select";
import { useCurrentOrgUsers } from "../../hooks/useCurrentOrgUsers";

/** Select value for "use the invoice assignee, falling back to the contact assignee" */
export const RECORD_ASSIGNEE = `record-assignee`;

interface IAssigneeProps {
  current: string | null;
  onChange: (id: string) => void;
  loading?: boolean;
  invalid?: IInvalidField;
  selectProps?: Partial<ISelectProps>;
  /** Offer the invoice/contact assignee option (value RECORD_ASSIGNEE) */
  allowRecordAssignee?: boolean;
}

export function Assignee({
  current,
  onChange,
  loading,
  invalid,
  selectProps,
  allowRecordAssignee,
}: IAssigneeProps) {
  const currentOrgUsers = useCurrentOrgUsers();

  const dropdownOpts: IOption[] = useMemo(() => {
    const options = currentOrgUsers.map(user => ({
      ...user,
      disabled: user.value === current,
    }));

    if (!options.find(u => u.value === current) && current) {
      options.unshift({
        label: `Removed User`,
        value: current,
        disabled: true,
      });
    }

    if (allowRecordAssignee) {
      options.unshift({
        label: `Invoice or Contact Owner`,
        value: RECORD_ASSIGNEE,
        disabled: current === RECORD_ASSIGNEE,
      });
    }

    return options;
  }, [currentOrgUsers, current, allowRecordAssignee]);

  return (
    <Select
      options={ dropdownOpts }
      loading={ loading }
      selected={ current }
      onChange={ ({ value }) => onChange(value) }
      emptyText={ `Unassigned` }
      nullable
      invalid={ invalid }
      { ...selectProps }
    />
  );
}
